export default __webpack_public_path__ + "alberta-diagnostics.d94984a718926473610b.svg";